import * as React from "react";
import { Navigate, useLocation, useSearchParams } from "react-router";

import { useContractFamiliesAccess } from "@/hooks/use-contract-families-access";

export const ContractFamilyProjectionGate: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { isResolved, hasContractFamilies } = useContractFamiliesAccess();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const requested = searchParams.get("contractFamilyProjection") === "true";

  if (!requested) return children;
  if (!isResolved) return null;
  if (hasContractFamilies) return children;

  const next = new URLSearchParams(searchParams);
  next.delete("contractFamilyProjection");
  const query = next.toString();
  return <Navigate to={`${location.pathname}${query ? `?${query}` : ""}`} replace />;
};
